<template>
  <div class="done-message-container">
    <i class="fas fa-clipboard-check"></i>
    <h2>Заявка принята, пароль и логин выслан на указанную вами почту</h2>
    <v-button @click="$router.push({name:'login'})" label="На страницу входа" />
    <div class="logos">
      <a href="https://tsu.ru">
        <img class="logo" src="../../assets/img/logos/tsu_logo_basic_sign.svg" alt="tsu" />
      </a>
      <a href="http://opendata.university/">
        <img class="logo" src="../../assets/img/logos/oduc.png" alt="oduc" />
      </a>
    </div>
  </div>
</template>

<script>
import vButton from "../vButton";

export default {
  name: "FormIsDone",
  components: {
    vButton
  }
};
</script>

<style lang="sass" scoped>
    .logos
        margin-top: gridSteps(3)
        justify-content: space-around
        flex-shrink: 0
        display: flex
        width: 100%

    .logo
        height: 80px


    .done-message-container
        width: 400px
        text-align: center
        display: flex
        justify-content: center
        align-items: center
        flex-direction: column
        i
            font-size: 140px

</style>